module.exports = __webpack_public_path__ + "static/media/kia-logo.15c61022.svg";